import Icon from '../../components/Icon.vue'

Icon.register({"regular/user-circle":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 56C366.5 56 456 145.5 456 256 456 293 446 327.6 428.5 357.3 421.4 331.9 402.8 303.1 364.5 292 377.2 271.8 384 248.4 384 224 384 153.3 326.8 96 256 96 185.3 96 128 153.2 128 224 128 248.4 134.8 271.8 147.5 292 109.2 303.1 90.6 331.9 83.5 357.3 66 327.6 56 293 56 256 56 145.5 145.5 56 256 56zM336 224C336 268.2 300.2 304 256 304S176 268.2 176 224 211.8 144 256 144 336 179.8 336 224zM128 409.7V381.9C128 361.5 141.5 343.6 161.2 338L185.6 331C206.3 344.6 230.6 352 256 352S305.7 344.6 326.4 331L350.8 338C370.5 343.6 384 361.5 384 381.9V409.7C349.3 438.6 304.7 456 256 456S162.7 438.6 128 409.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/user-circle.js
// module id = null
// module chunks = 